export  const TipoNormativoEnum = {
    ATO_REGULAMENTAR : {text:"Ato Regulamentar",value:"ato regulamentar"},    
    COMUNICADO: {text:"Comunicado",value:"comunicado"},
    EMENDA_REGIMENTAL: {text:"Emenda Regimental",value:"emenda regimental"},    
    INSTRUCAO_NORMATIVA: {text:"Instrução Normativa",value:"instrução normativa"},
    MANUAL_ORGANIZACAO: {text:"Manual de Organização",value:"manual de organização"},
    NORMA_PRAZO_FERIADO: {text:"Norma de Prazo e Feriado",value:"norma de prazo e feriado"},
    ORDEM_SERVICO: {text:"Ordem de Serviço",value:"ordem de serviço"},
    PORTARIA: {text:"Portaria",value:"portaria"},
    PORTARIA_CONJUNTA_GP: {text:"Portaria Conjunta (GP)",value:"portaria conjunta gp"},    
    PROCEDIMENTO_JUDICIARIO: {text:"Procedimento Judiciário",value:"procedimento judiciário"},
    REGIMENTO_INTERNO: {text:"Regimento Interno",value:"regimento interno"},
    REGULAMENTO_SECRETARIA: {text:"Regulamento da Secretaria",value:"regulamento da secretaria"},
    RESOLUCAO: {text:"Resolução",value:"resolução"},
    RESOLUCAO_CONJUNTA: {text:"Resolução Conjunta",value:"resolução conjunta"},   
}
export default TipoNormativoEnum;

